// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Editor-module__root___3p2h6{position:relative}\n", "",{"version":3,"sources":["/home/ubuntu/afweb/rails/releases/20260528203555/app/javascript/Article/components/Editor.module.scss"],"names":[],"mappings":"AAAA,6BACE,iBAAkB","file":"Editor.module.scss","sourcesContent":[".root {\n  position: relative;\n}\n"]}]);
// Exports
exports.locals = {
	"root": "Editor-module__root___3p2h6"
};
module.exports = exports;
